"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _react = _interopRequireDefault(require("react"));
var Spinner = exports.Spinner = function Spinner(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 64 64",
    className: "btn-loading ".concat(size === 'sm' ? 'btn-loading_sm' : '')
  }, /*#__PURE__*/_react["default"].createElement("g", {
    strokeWidth: "4",
    strokeLinecap: "round"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(180)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(210)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: "0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(240)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(270)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(300)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(330)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(0)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(30)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(60)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(90)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(120)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "12",
    y2: "20",
    transform: "translate(32,32) rotate(150)"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
    repeatCount: "indefinite"
  }))));
};